export default function (props: any) {
    return (
        <svg
            width="43px"
            height="44px"
            viewBox="0 0 43 44"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="-Smart-Generator-(Dual-Fuel)" transform="translate(-646.000000, -6074.000000)">
                    <g id="编组-36" transform="translate(612.000000, 6074.000000)">
                        <g id="Time-Saving" transform="translate(34.000000, 0.000000)">
                            <rect id="矩形" fillOpacity="0" fill="#49E1F9" x="0" y="0" width="43" height="44"></rect>
                            <ellipse id="椭圆形" stroke="#49E1F9" strokeWidth="2.79542061" cx="21.5" cy="22.6875" rx="20.1022897" ry="19.9147897"></ellipse>
                            <path
                                d="M21.7934424,10.3850579 C21.7934424,18.3850579 21.7934424,22.3850579 21.7934424,22.3850579 C21.7934424,22.3850579 19.4601091,22.3850579 14.7934424,22.3850579"
                                id="路径-10"
                                stroke="#49E1F9"
                                strokeWidth="2.68790443"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
